import React from 'react';

import { IChallengeItem } from '../../helpers/fetch-service';

import './FormGroup.css';

interface Props {
  children: React.ReactElement | null;
  formik: any;
}

const FormGroup: React.FC<Props> = ({ children, formik }) => {
  const childIds = children?.props?.template?.map((el: IChallengeItem) => el?.dataId);
  const errorId: string = childIds?.find((id: string) => formik.errors[id] && formik.touched[id]);
  const error = formik.errors[errorId] || '';

  return (
    <div className="ui-widget-form-group-wrapper">
      <div className="ui-widget-form-group">{children}</div>
      <div className="ui-widget-error-group-wrapper">
        {error && <div className="ui-widget-error-group">{error}</div>}
      </div>
    </div>
  );
};

export default FormGroup;
